import { render } from "./SelectUser.vue?vue&type=template&id=2cb6df76&scoped=true"
import script from "./SelectUser.vue?vue&type=script&lang=js"
export * from "./SelectUser.vue?vue&type=script&lang=js"

import "./SelectUser.vue?vue&type=style&index=0&id=2cb6df76&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb6df76"]])

export default __exports__